<template>
  <q-item v-bind="$attrs" @click="view">
    <q-item-section>
      <q-item-label>
        <p class="q-mb-sm">
          Post search results for
          <strong>{{ $filters.clientName(data.client) }}</strong>
          are ready to view.
        </p>
      </q-item-label>
      <q-item-label caption>
        <slot></slot>
      </q-item-label>
    </q-item-section>
  </q-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { name as clientName } from '@/client/client-filter';
import openModal from '@/components/modal';
import PostSearchModal from '@/social/post/search/PostSearchModal.vue';

interface PostSearchComplete {
  id: number,
  client: {
    id: number,
    firstName: string,
    lastName: string
  }
}

export default defineComponent({
  props: {
    data: {
      type: Object as () => PostSearchComplete,
      required: true,
    },
  },
  methods: {
    view() {
      const config = {
        parent: this,
        postSearchId: this.data.id,
      };
      openModal(PostSearchModal, config);
    },
  },
  filters: {
    clientName,
  },
});
</script>
